import {
  mdiAccountOutline,
  mdiAlertCircle,
  mdiAlertOctagon,
  mdiChartBar,
  mdiCheckCircle,
  mdiContentCopy,
  mdiCreditCardOutline,
  mdiDotsHorizontal,
  mdiEye,
  mdiEyeOff,
  mdiInformation,
  mdiKeyOutline,
  mdiOpenInNew,
  mdiPlaylistCheck,
  mdiTrashCanOutline
} from '@mdi/js';

// Only these SVG glyphs are bundled; Vuetify supplies its control aliases.
export const appIconAliases = {
  'account-outline': mdiAccountOutline,
  'alert-circle': mdiAlertCircle,
  'alert-octagon': mdiAlertOctagon,
  'chart-bar': mdiChartBar,
  'check-circle': mdiCheckCircle,
  'content-copy': mdiContentCopy,
  'credit-card-outline': mdiCreditCardOutline,
  'dots-horizontal': mdiDotsHorizontal,
  'eye': mdiEye,
  'eye-off': mdiEyeOff,
  'information': mdiInformation,
  'key-outline': mdiKeyOutline,
  'open-in-new': mdiOpenInNew,
  'playlist-check': mdiPlaylistCheck,
  'trash-can-outline': mdiTrashCanOutline,
};
